/**
 * Format INCI names for display — mirrors PCE frontend/src/lib/inciDisplayName.ts
 * Converts ALL-CAPS OCR labels to readable title case without changing slugs/keys.
 */
(function (global) {
  var HYPHEN_PREFIX_CODES = /^[A-Z0-9]{1,3}$/i;
  var INCI_ACRONYMS = {
    NP: true,
    AP: true,
    EOP: true,
    PCA: true,
    EDTA: true,
    HCL: true,
    BHT: true,
    BHA: true,
    AHA: true,
    PH: true,
    CI: true,
  };

  function letterRatioUpper(name) {
    var letters = name.replace(/[^a-zA-Z]/g, '');
    if (letters.length < 3) return 0;
    var upper = letters.replace(/[^A-Z]/g, '').length;
    return upper / letters.length;
  }

  function isMostlyUppercaseInci(name) {
    return letterRatioUpper(name) >= 0.85;
  }

  function titleCaseWord(word) {
    if (!word) return word;
    if (INCI_ACRONYMS[word.toUpperCase()]) return word.toUpperCase();
    if (word.length <= 1) return word.toUpperCase();
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  }

  function titleCaseToken(token) {
    if (!token) return token;
    if (/^\d[\d.,]*$/.test(token)) return token;

    var numericPrefix = token.match(/^(\d[\d.,]*[-.]?)(.+)$/i);
    if (numericPrefix) {
      return numericPrefix[1] + titleCaseToken(numericPrefix[2]);
    }

    if (token.indexOf('-') !== -1) {
      return token
        .split('-')
        .map(function (part, index) {
          if (index === 0 && HYPHEN_PREFIX_CODES.test(part)) return part.toUpperCase();
          if (HYPHEN_PREFIX_CODES.test(part) && /^\d+$/.test(part)) return part;
          return titleCaseWord(part);
        })
        .join('-');
    }

    if (token.indexOf('/') !== -1) {
      return token.split('/').map(titleCaseToken).join('/');
    }

    if (token === token.toUpperCase() && /[A-Z]/.test(token)) {
      return titleCaseWord(token);
    }

    return token;
  }

  function formatSegment(segment) {
    return segment
      .split(/(\s+)/)
      .map(function (part) {
        return /^\s+$/.test(part) ? part : titleCaseToken(part);
      })
      .join('');
  }

  function formatInciDisplayName(name) {
    var trimmed = name ? String(name).trim() : '';
    if (!trimmed) return name;
    if (!isMostlyUppercaseInci(trimmed)) return trimmed;

    return trimmed
      .split(/(\([^)]*\))/g)
      .filter(Boolean)
      .map(function (part) {
        if (part.charAt(0) === '(' && part.charAt(part.length - 1) === ')') {
          return '(' + formatSegment(part.slice(1, -1)) + ')';
        }
        return formatSegment(part);
      })
      .join('');
  }

  global.formatInciDisplayName = formatInciDisplayName;
})(typeof window !== 'undefined' ? window : globalThis);
